export default "__VITE_ASSET__CKQCrBMa__"